import { IRequest } from "@uxland/harmonix";

export interface ExitShellPayload {
  ecapEvent?: string;
  payload?: any;
}

export class ExitShell implements IRequest<void> {
  constructor(public ecapEvent?: string, public payload?: {}) {}
}
